import { Component, input, output, ViewEncapsulation } from '@angular/core';

/**
 * Native modal CHROME host: reproduces the AngularJS ftModal v1 chrome
 * (`.ft-modal` → `.ft-modal-container` → `.ft-modal-content` → form with
 * header/body/footer). Projected body goes in `.modal-body`. Chrome only — it
 * does not own the show/hide registry; `done`/`cancel` outputs drive the shell.
 */
@Component({
    selector: 'ft-modal-chrome-ng',
    encapsulation: ViewEncapsulation.None,
    templateUrl: './ft-modal-chrome.component.html',
})
export class FtModalChromeComponent {
    /** v1 ftModal `options` (modal.js:140-151 defaults). */
    readonly headerText = input('');
    readonly headerDescription = input('');
    readonly doneText = input('Save');
    readonly footerCancelText = input('Cancel');
    readonly footerAlign = input('right');
    /** One of xs/sm/md/lg/xl/full → `.ft-modal-container` max-width (global `_modal.less`). */
    readonly size = input('sm');
    /** Extra class on the `.ft-modal` root (v1 `<ft-modal class="…">`, e.g. `contest-theme-modal`). */
    readonly modalClass = input('');
    readonly doneVisible = input(true);
    /** v1 `ng-disabled="modalForm.$invalid"` + `ng-class {'disabled': …}` on the Done
     *  button (modal_v1.html:24-26) — the consumer owns the form (projected content
     *  cannot register with this template's `<form>`), so it passes validity in.
     *  Additive, default false: pre-2y consumers are unaffected. (The v1 `ft-disabled`
     *  DOM attr stays dropped — the documented 2x-era divergence.) */
    readonly doneDisabled = input(false);
    readonly cancelVisible = input(true);
    readonly footerVisible = input(true);
    readonly footerCancelVisible = input(false);

    /** Wired to the registry shell's `modalScope.done()` (on-done="done()"). */
    readonly done = output<void>();
    /** Wired to the registry shell's `modalScope.cancel()` (on-cancel="cancel()"). */
    readonly cancel = output<void>();
}
